import { render } from "./CartPage.vue?vue&type=template&id=4dfba3b0&scoped=true&ts=true"
import script from "./CartPage.vue?vue&type=script&lang=ts"
export * from "./CartPage.vue?vue&type=script&lang=ts"

import "./CartPage.vue?vue&type=style&index=0&id=4dfba3b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfba3b0"]])

export default __exports__